<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>

    <Employees />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Employees from "../../components/Workflow/Definitions/Employees.vue";
export default {
  components: { LandingToolbar, Employees },
};
</script>
